const routes = [
  {
    path: '/pages',
    name: 'Pages',
    component: () => import(
      /* webpackChunkName: "PagesModule" */
      '@/modules/Pages/PagesModule.vue'
    ),
    meta: {
      mainClasses: 'App-main__withall',
      hideAside: false,
      hideFooter: true,
      requiresAuth: true,
      requiresAccountSelected: true,
      accountSettingsPage: true,
    },
    children: [
      {
        path: '',
        name: 'pages-list',
        component: () => import(
          /* webpackChunkName: "PagesModule" */
          '@/modules/Pages/views/PagesList/PagesList.vue'
        ),
        children: [
          {
            path: 'new',
            name: 'pages-new',
            component: () => import(
              /* webpackChunkName: "PagesModule" */
              '@/modules/Pages/views/PagesForm/PagesForm.vue'
            ),
          },
          {
            path: ':id',
            name: 'pages-edit',
            component: () => import(
              /* webpackChunkName: "PagesModule" */
              '@/modules/Pages/views/PagesForm/PagesForm.vue'
            ),
          },
        ],
      },
    ],
  },
];

export default routes;
